// src\themes\eram\components\SpecGridWidget.tsx
import Image from "next/image";

type SpecGridItem = {
    title?: string;
    image?: {
        url: string;
        name?: string;
        description?: string;
    };
};

type SpecGridWidgetData = {
    title?: string;
    description?: string;
    items?: SpecGridItem[];
    direction?: 'left' | 'right' | 'center';
};

export default function SpecGridWidget({ data }: { data: SpecGridWidgetData }) {
    const items = data?.items || [];

    if (!items.length) return null;

    const itemsTextAlign =
        data.direction === 'center'
            ? 'text-center'
            : data.direction === 'left'
                ? 'text-end'
                : 'text-start';

    const itemsAlign =
        data.direction === 'center'
            ? 'items-center'
            : data.direction === 'left'
                ? 'items-end'
                : 'items-start';

    return (
        <div className="col-span-12 space-y-8">
            {(data.title || data.description) && (
                <div className="space-y-2 text-start">
                    {data.title && (
                        <h2 className="text-2xl lg:text-3xl font-light text-primary-900 tracking-tight">
                            {data.title}
                        </h2>
                    )}
                    {data.description && (
                        <p className="text-primary-600 text-sm leading-6 max-w-2xl">
                            {data.description}
                        </p>
                    )}
                </div>
            )}

            <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14 ${itemsTextAlign}`}>
                {items.map((item, index) => (
                    <div key={index} className={`flex flex-col gap-4 ${itemsAlign}`}>
                        {item.title && (
                            <p className="text-[11px] sm:text-xs font-medium tracking-wider uppercase text-primary-900 pl-12">
                                {item.title}
                            </p>
                        )}
                        {item.image?.url && (
                            <div className="relative w-full aspect-[4/3] bg-white">
                                <Image
                                    src={item.image.url}
                                    alt={item.title || ""}
                                    fill
                                    className="object-contain"
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}